function getRealmSlug (realmObj) {
  if (!realmObj) return null
  return realmObj.slug
}

export { getRealmSlug }
